import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Form } from 'react-final-form'
import './styles.scss'
import user from '../../shared/user'
import ReactTooltip from 'react-tooltip'

//import l10n from '../../shared/l10n'
//const { foo: { foo } } = l10n

const UnlockOguloTour = ({
  courtagepflichtig,
  error,
  success,
  isSubmitting,
  submit,
}) => {
  useEffect(() => {
    ReactTooltip.rebuild()
  })

  const handleSubmit = values => {
    values.oguloparam = 'ogulo'
    submit(values)
  }

  //const validation = values =>
  //  courtagepflichtig || (values.verzicht_auf_widerruf && values.maklerauftrag)

  return (
    <div className={`dhsv_unlock_ogulo_tour`}>
      {success && (
        <div className={`dhsv_success_message`}>
          <p>{success}</p>
        </div>
      )}
      {error && (
        <div className={`dhsv_error_message`}>
          <p>{error}</p>
        </div>
      )}
      {!success && !error && (
        <Form
          onSubmit={handleSubmit}
          render={({ handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              {!user.newsletter && (
                <>
                  <p>
                    Durch Klick auf „Bestätigen“ stimme ich zu, regelmäßig über
                    relevante Inhalte, Produkte und Services per E-Mail, Telefon
                    und Post informiert zu werden. Auch habe ich die{' '}
                    <a href="/datenschutz" target="_blank">
                      Datenschutzerklärung
                    </a>{' '}
                    zur Kenntnis genommen. Widerruf jederzeit{' '}
                    <a href="/datenschutz" target="_blank">
                      hier
                    </a>{' '}
                    möglich.
                  </p>
                  <p>
                    Zur{' '}
                    <a href="/datenschutz" target="_blank">
                      Datenschutzerklärung.
                    </a>
                  </p>
                </>
              )}
              <div className="buttons">
                <button
                  className={`btn btn--primary`}
                  type="submit"
                  disabled={courtagepflichtig === false ? false : isSubmitting}
                >
                  Bestätigen
                </button>
              </div>
            </form>
          )}
        />
      )}
    </div>
  )
}

UnlockOguloTour.propTypes = {
  courtagepflichtig: PropTypes.bool,
  error: PropTypes.string,
  success: PropTypes.string,
  isSubmitting: PropTypes.bool,
  submit: PropTypes.func,
}

export default UnlockOguloTour
